var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.043,
    height: 12.27,
    viewBox: "0 0 11.043 12.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M8.093,0a2.688,2.688,0,0,1,2.95,2.963h0V9.3a2.679,2.679,0,0,1-2.95,2.969H2.951A2.693,2.693,0,0,1,0,9.3H0V2.963A2.7,2.7,0,0,1,2.951,0H8.093ZM3.117,8.429a.481.481,0,0,0-.46.227.488.488,0,0,0,0,.515.477.477,0,0,0,.46.221h4.81a.485.485,0,0,0,0-.963H3.117Zm4.81-2.8H3.117a.479.479,0,0,0,0,.958h4.81a.479.479,0,0,0,0-.958ZM4.95,2.853H3.117v.006a.479.479,0,0,0,0,.957H4.95a.482.482,0,0,0,0-.963Z",
    fill: "#006eff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.78b97c1f76a214f581f8ade5d50c8879.svg";
export { ForwardRef as ReactComponent };